/* Media presentation only. Never writes a variant, offer, quantity or cart. */
class MizuroProductMedia extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    const section = this.closest('.shopify-section');
    // Kaching updates the existing Shopify form but does not always emit the
    // theme's variant:update event. Read that form after its change has settled;
    // only the native gallery moves. Bundle selections are never written here.
    section?.addEventListener('change', event => {
      const picker = event.target.closest?.('variant-picker');
      if (!picker || picker.dataset.productId !== this.dataset.productId) return;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (this.isConnected) this.followNativeVariant();
      }));
    }, { capture:true, signal });
  }
  disconnectedCallback() {
    this.controller?.abort();
  }
  followNativeVariant() {
    const section = this.closest('.shopify-section');
    const variantId = section?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    if (!variantId || variantId === this.lastVariantId) return;
    let product;
    try { product = JSON.parse(section.querySelector('[data-mz-product]').textContent); } catch { return; }
    if (String(product.id) !== this.dataset.productId) return;
    const mediaId = product.variants.find(variant => String(variant.id) === variantId)?.featured_media?.id;
    if (!mediaId) return;
    const slideshow = this.querySelector('media-gallery')?.slideshow;
    const index = slideshow?.slides?.findIndex(slide => String(slide.querySelector('[data-media-id]')?.dataset.mediaId) === String(mediaId));
    if (index === undefined || index < 0) return;
    this.lastVariantId = variantId;
    slideshow.select(index, undefined, { animate:!matchMedia('(prefers-reduced-motion: reduce)').matches });
  }
}
if (!customElements.get('mz-product-media')) customElements.define('mz-product-media', MizuroProductMedia);

// Shopify's recommendation endpoint owns ranking. Keep server-rendered cards
// when the service is unavailable, empty, or JavaScript is disabled.
class MizuroProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.recommendationsPerformed === 'true') return;
    this.observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.load();
    }, { rootMargin:'400px 0px' });
    this.observer.observe(this);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.controller?.abort();
  }
  async load() {
    this.controller = new AbortController();
    try {
      const response = await fetch(this.dataset.url, { signal:this.controller.signal });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = html.querySelector('mz-product-recommendations');
      const grid = source?.querySelector('[data-mz-recommendation-grid]');
      if (source?.dataset.recommendationsPerformed !== 'true' || !grid?.querySelector('.mz-card')) return;
      if (!this.isConnected) return;
      this.querySelector('[data-mz-recommendation-grid]').replaceWith(grid);
      this.dataset.recommendationsPerformed = 'true';
    } catch (error) {
      if (error.name !== 'AbortError') this.dataset.recommendationsFallback = 'true';
    }
  }
}
if (!customElements.get('mz-product-recommendations')) customElements.define('mz-product-recommendations', MizuroProductRecommendations);
